import { render, staticRenderFns } from "./JtiExpansionPanel.vue?vue&type=template&id=55316f73"
import script from "./JtiExpansionPanel.vue?vue&type=script&lang=js"
export * from "./JtiExpansionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports